import { useEffect } from "react";
import { RecipeList } from "./components/RecipeList";
import { RecipeDetail } from "./components/RecipeDetail";
import { VeggieMap } from "./components/VeggieMap";
import { navigate, useRoute } from "./router";
import { detectLang } from "./i18n";
import "./index.css";

export function App() {
  const { lang, slug } = useRoute();

  // First visit only: a French browser landing on the English root → /fr.
  // A stored choice (from the toggle) or an explicit path is always respected.
  useEffect(() => {
    let stored: string | null = null;
    try {
      stored = localStorage.getItem("lang");
    } catch {
      /* ignore */
    }
    if (!stored && window.location.pathname === "/" && detectLang() === "fr") {
      navigate("/fr");
    }
  }, []);

  if (slug === "map" || slug === "carte") return <VeggieMap />;

  return slug ? <RecipeDetail lang={lang} slug={slug} /> : <RecipeList lang={lang} />;
}

export default App;
